import { FavouriteDataAdapter } from './favourite-data-adapter';
import { LayoutConfig } from './layout-config';

export class FavouriteDataOptions {
  public layoutConfig: LayoutConfig;
  public dataAdapter: FavouriteDataAdapter;

  private columnTitles: any = {};

  constructor(config: LayoutConfig, dataAdapter: FavouriteDataAdapter) {
    this.layoutConfig = config;
    this.dataAdapter = dataAdapter;
  }

  private columnTitleSetting(columnIndex: number, setting: string, section: string): any {
    const columnType = this.dataAdapter.columnType(columnIndex);
    const colTitles = this.layoutConfig.layoutAttributes.columnTitles;
    if (colTitles) {
      if (colTitles[section] && colTitles[section][columnType] && colTitles[section][columnType][setting] !== undefined) {
        return colTitles[section][columnType][setting];
      }
      if (colTitles[section] && colTitles[section][setting] !== undefined) {
        return colTitles[section][setting];
      }
      if (colTitles[columnType] && colTitles[columnType][setting] !== undefined) {
        return colTitles[columnType][setting];
      }
      if (colTitles[setting] !== undefined) {
        return colTitles[setting];
      }
    }
    return undefined;
  }

  public disableColumnTitle(columnIndex: number, section: string): boolean {
    return this.columnTitleSetting(columnIndex, 'disableTitle', section) === true;
  }

  public showLongColumnDescription(columnIndex: number, section: string): boolean {
    return this.columnTitleSetting(columnIndex, 'showLongDescription', section) === true;
  }

  public showExtraColumnText(columnIndex: number, section: string): boolean {
    if (this.dataAdapter.columnType(columnIndex) === 'selection') {
      const col = this.dataAdapter.dataModel.columns[columnIndex];
      const ids = (this.columnTitleSetting(columnIndex, 'hideExtraTextForSelectionTypes', section) || '').toString().split(',');
      const selectionTypes: number[] = [];
      for (let i = 0; i < ids.length; i++) {
        selectionTypes.push(parseInt(ids[i], 10));
      }
      if (col && (selectionTypes.indexOf(col.selectionType) >= 0)) {
        return false;
      }
    }
    return this.columnTitleSetting(columnIndex, 'showExtraText', section) === true;
  }

  public getColumnTitle(colIndex: number, section?: string, append: boolean = true): string {
    if (colIndex >= this.dataAdapter.dataModel.columns.length) {
      return '';
    }

    if (!section) {
      section = 'default';
    }

    if (!this.columnTitles[section] || !this.columnTitles[section][colIndex]) {
      if (!this.columnTitles[section]) {
        this.columnTitles[section] = [];
        this.columnTitles[section].length = this.dataAdapter.dataModel.columns.length;
      }

      const column = this.dataAdapter.dataModel.columns[colIndex];
      if (!column) {
        return undefined;
      }

      if (this.disableColumnTitle(colIndex, section)) {
        return null;
      }

      let text = column.shortText || '';
      if (this.showLongColumnDescription(colIndex, section)) {
        text = column.text || text;
      }

      if (column.extraText && this.showExtraColumnText(colIndex, section)) {
        text += (text.length > 0 ? ', ' : '') + column.extraText;
      }

      if (column.columnType === 'aggregationRollAvg' && column.rollingAverageText) {
        text = column.rollingAverageText;
      } else if (column.columnType === 'target' && column.targetText) {
        text = column.targetText + (append ? ' - ' + text : '');
      }

      this.columnTitles[section][colIndex] = text;
    }
    return this.columnTitles[section][colIndex];
  }
}
